import { getJsNow } from 'utils/date';
import DbService from 'resources/db.service';
import schema from './comment.schema';
import { COMMENT_TYPES } from './comment.constants';


const service = new DbService('comments', { schema });

const createAuditComment = async ({
  id,
  createdBy,
  auditId,
  taskId, documentId, // or
  content, // null
}) => {
  const { data } = await service.create({
    ...(id && { id }),
    created_by: createdBy,
    audit_id: auditId,
    ...(taskId && { task_id: taskId }),
    ...(documentId && { document_id: documentId }),
    type: COMMENT_TYPES.AUDIT,
    ...(content && { content }),
    is_need_resolve: true,
  });

  return data[0];
};

const resolveAuditComments = async ({
  id, auditId, taskId, documentId, // or
  resolvedBy,
}) => {
  const { data } = await service.updateOne({
    ...(id && { id }),
    ...(auditId && { audit_id: auditId }),
    ...(taskId && { task_id: taskId }),
    ...(documentId && { document_id: documentId }),
  }, {
    is_need_resolve: false,
    resolved_on: getJsNow(),
    resolved_by: resolvedBy,
  });

  return data;
};

const getAuditCommentsToResolve = async (auditId) => {
  const data = await service.find({
    audit_id: auditId,
    type: COMMENT_TYPES.AUDIT,
    is_need_resolve: true,
  });

  return data;
};

const getTaskAuditCommentsToResolve = async (taskId) => {
  const data = await service.find({
    type: COMMENT_TYPES.AUDIT,
    is_need_resolve: true,
    task_id: taskId,
  });

  return data;
};

const getTasksAuditCommentsToResolve = async (taskIds) => {
  // let response = await service
  //   .select()
  //   .match({
  //     type: COMMENT_TYPES.AUDIT,
  //     is_need_resolve: true,
  //   })
  //   .in('task_id', taskIds);

  let response = await service.selectByKey({
    selectKey: 'getTasksAuditCommentsToResolve',
    params: { taskIds },
  });
  
  response = service.processResponse(response);

  return response?.data;
};

const getDocumentAuditCommentsToResolve = async (documentId) => {
  const data = await service.find({
    type: COMMENT_TYPES.AUDIT,
    is_need_resolve: true,
    document_id: documentId,
  });

  return data;
};

export default Object.assign(service, {
  createAuditComment,
  resolveAuditComments,
  getAuditCommentsToResolve,
  getTaskAuditCommentsToResolve,
  getDocumentAuditCommentsToResolve,
  getTasksAuditCommentsToResolve,
});
